import type { SVGProps } from "react";
const SvgGreenPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="url(#greenPlus_svg__a)"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
    />
    <path
      fill="url(#greenPlus_svg__b)"
      d="M12 3.375c4.756 0 8.625 3.87 8.625 8.625 0 4.756-3.87 8.625-8.625 8.625-4.756 0-8.625-3.87-8.625-8.625 0-4.756 3.87-8.625 8.625-8.625M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
    />
    <path
      fill="url(#greenPlus_svg__c)"
      d="M16.5 12.75h-3.75v3.75a.75.75 0 1 1-1.5 0v-3.75H7.5a.75.75 0 1 1 0-1.5h3.75V7.5a.75.75 0 1 1 1.5 0v3.75h3.75a.75.75 0 1 1 0 1.5"
    />
    <defs>
      <linearGradient
        id="greenPlus_svg__a"
        x1={5.636}
        x2={18.364}
        y1={5.636}
        y2={18.364}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4EA974" />
        <stop offset={1} stopColor="#61D18D" />
      </linearGradient>
      <linearGradient
        id="greenPlus_svg__b"
        x1={5.636}
        x2={18.364}
        y1={5.636}
        y2={18.364}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.6} />
        <stop offset={0.493} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.997} stopColor="#fff" stopOpacity={0.3} />
      </linearGradient>
      <linearGradient
        id="greenPlus_svg__c"
        x1={9.22}
        x2={14.78}
        y1={9.22}
        y2={14.78}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.8} />
        <stop offset={0.519} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.6} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgGreenPlus;
